import { css } from '@emotion/react';
import { FONT_FAMILY } from '../../constants';

export const useStyles = (props) => ({
  chipContainer: css({
    display: "inline-flex",
    alignItems: "center",
    boxSizing: "border-box",
    padding: "0px 10px 0px 10px",
    borderRadius: 13,
    fontFamily: FONT_FAMILY.ROBOTO_MEDIUM,
    fontSize: 12,
    background: props.backgroundColor,
    color: props.color,
    "& svg": {
      width: 16,
      height: 16,
      marginRight: 8,
    },
  }),
});
